import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Flex, Box, Text, Formik, ButtonFilled } from 'Components/Base';
import Loading from 'Components/Loading';

const { FormContainer, Form, FormikInput } = Formik;
const { Input, TextArea } = FormikInput;

const ClearTicketForm = ({ onSubmit, loading, initialValues, children }) => {
  const { t } = useTranslation('classroom');

  const videoDetailFields = [
    {
      name: 'courseName',
      label: t('CLEAR_BY_LEARNED.FORM.COURSE_NAME.LABEL'),
    },
    {
      name: 'videoTitle',
      label: t('CLEAR_BY_LEARNED.FORM.VIDEO_TITLE.LABEL'),
    },
    {
      name: 'videoTime',
      label: t('CLEAR_BY_LEARNED.FORM.VIDEO_TIME.LABEL'),
    },
  ];

  const validateClearTicketForm = ({ question, ...rest }) => {
    const error = {};

    if (!question) error.question = t('CLEAR_BY_LEARNED.FORM.MESSAGE.REQUIRED');
    return error;
  };

  return (
    <Flex flexDirection="column" width="100%">
      <Text color="greyscale.grey3" mt={4}>
        {t('CLEAR_BY_LEARNED.FORM.HEADER_CAPTION')}
      </Text>
      <Text textStyle={'subtitle1'} mt={6}>
        {t('CLEAR_BY_LEARNED.FORM.QUESTION_TYPE')}
      </Text>
      <Flex mt={2} mb={7} alignItems="baseline">
        <Text textStyle={'body2'}>{t('CLEAR_BY_LEARNED.FORM.FILE_ONLY')}</Text>
      </Flex>
      {children}
      <FormContainer
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        validate={validateClearTicketForm}
      >
        <Form id="learned-clear-ticket-form">
          <TextArea
            name="question"
            label={
              <Text textStyle={'subtitle1'} display="inline-block">
                {t('CLEAR_BY_LEARNED.FORM.MESSAGE.LABEL')}
              </Text>
            }
            required
            placeholder={t('CLEAR_BY_LEARNED.FORM.MESSAGE.PLACEHOLDER')}
            rows={7}
            rowsMax={7}
          />
          <Text textStyle={'subtitle1'} mt={6}>
            {t('CLEAR_BY_LEARNED.FORM.MESSAGE_DETAILS')}
          </Text>
          {videoDetailFields.map((field) => (
            <Box key={field.name} mt={4}>
              <Input disabled {...field} />
            </Box>
          ))}

          <ButtonFilled mt={4} width={1} type="submit" borderRadius="8px" disabled={loading}>
            {loading ? <Loading width={20} height={20} /> : t('CLEAR_BY_LEARNED.FORM.SUBMIT')}
          </ButtonFilled>
        </Form>
      </FormContainer>
    </Flex>
  );
};

ClearTicketForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  loading: PropTypes.bool,
};
ClearTicketForm.defaultProps = {
  onSubmit: () => {},
};
export default ClearTicketForm;
